import { useAuth } from "@/contexts/AuthContext";
import Fees from "./Fees";
import StudentSelfFinance from "./StudentSelfFinance";

const FinanceEntry = () => {
  const { user } = useAuth(); const roles = new Set(user?.roles || (user?.role ? [user.role] : []));
  return roles.has("student") && !["super_admin", "director", "accountant", "receptionist"].some((role) => roles.has(role)) ? <StudentSelfFinance /> : <Fees />;
};
export default FinanceEntry;
